export default __webpack_public_path__ + "static/media/Backword_Arrow.4d4daeb5.svg";